module.exports = __webpack_public_path__ + "static/img/googlePay.d78afe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/googlePay.png
// module id = iCYg
// module chunks = 1